import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export enum REQUESTSTATUS {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}

export type TRecalculateTask = {
  wheatCodeId: number
  taskId: string
  status: REQUESTSTATUS
}

interface IRecalculateBinState {
  wheatCodeWithTaskIds: TRecalculateTask[] | null
}

const initialState: IRecalculateBinState = {
  wheatCodeWithTaskIds: null,
}

const recalculateBinSlice = createSlice({
  name: 'recalculateBin',
  initialState,
  reducers: {
    // Add whaet code that is being recalculated with its task id
    addWheatCodeWithTaskIds: (
      state,
      action: PayloadAction<TRecalculateTask>
    ) => {
      if (!state.wheatCodeWithTaskIds) {
        state.wheatCodeWithTaskIds = []
      }
      state.wheatCodeWithTaskIds.push(action.payload)
    },
    updateWheatCodeWithTaskIdStatus: (
      state,
      action: PayloadAction<{ taskId: string; status: REQUESTSTATUS }>
    ) => {
      if (!state.wheatCodeWithTaskIds) return

      const { taskId, status } = action.payload

      const task = state.wheatCodeWithTaskIds.find((t) => t.taskId === taskId)
      if (task) {
        task.status = status
      }
    },
    // Remove whaet code that finished calculation according to wheatCodeId
    removeWheatCodeWithTaskIds: (state, action: PayloadAction<number>) => {
      if (state.wheatCodeWithTaskIds) {
        state.wheatCodeWithTaskIds = state.wheatCodeWithTaskIds.filter(
          (item) => item.wheatCodeId !== action.payload
        )
        if (state.wheatCodeWithTaskIds.length === 0) {
          state.wheatCodeWithTaskIds = null
        }
      }
    },
  },
})

export const {
  addWheatCodeWithTaskIds,
  updateWheatCodeWithTaskIdStatus,
  removeWheatCodeWithTaskIds,
} = recalculateBinSlice.actions

export default recalculateBinSlice.reducer
